import React from 'react'
import * as  C from "../componentsM/index"

const MYPAssessments = () => {
    return (
        <>

            <C.Hero title={"MYP ASSESSMENTS"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

<h1 className='text-xl md:text-3xl font-bold text-myBlue'>A) Internal</h1>

<p>Department exams, tests, quizzes, home assignments, completed projects and other subject specific tasks evaluate the student’s academic progress.</p>

<p>Student progress is then recorded by pre-formative and summative assessments. While pre-assessments assess prior knowledge and formative assessments allow for adjustments in teaching strategies, summative assessments are the main/ end of unit assessment by which teachers are able to gauge the level of attainment of recently acquired knowledge. Student progress for all assessments is indicated in the bi-monthly, mid-term and final reports.</p>

<h1 className='text-xl md:text-3xl font-bold text-myBlue'>B) External</h1>

<p>At the end of the five year MYP cycle, students are awarded by the IBO:</p>

<p>1: Course results</p>
<p>2: The MYP Certificate</p>


<p>All students regardless of their educational accomplishments will be given the course results; an IBO validated marks sheet, at the end of the MYP cycle (year 5). However, the MYP Certificate will ONLY be awarded to students who satisfy the following conditions:</p>


        
<h1 className='text-xl md:text-3xl font-bold text-myBlue'> MYP Assessment Criteria</h1>

<p>The MYP offers a criterion-referenced model of assessment. Therefore students’ results are determined by performance against set standards.

All criteria have a maximum achievement level of 8.

Description of Subject Criteria:
</p>


                </div>
            </section>

        </>

    )
}

export default MYPAssessments